import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import Validators from "../../assets/js/utils/appValidators";
const FieldText = (({ componentID = "", inputName = "", titleLabel = "", subtitleLabel = "", placeholder = "", inputValue = "", feedbackMessage = "", isRequired = false }) => {
    const [touched, setTouched] = useState(false);
    const [isValidateTriggered, setIsValidateTriggered] = useState(false);
    const [inputText, setInputText] = useState(inputValue); //to avoid input blockage this value should be the value on tag "value" in HTML component
    const isValid = !isRequired || Validators.isNotEmpty(inputText);
    const showInvalid = !isValid && (touched || isValidateTriggered);
    useEffect(() => {
        const event = new CustomEvent('text-field-updated', {
            detail: {
                componentID: componentID,
                value: inputText,
                isValid: isValid
            }
        });
        window.dispatchEvent(event);
    }, [inputText]);
    useEffect(() => {
        const handleIsValidateTriggered = () => {
            setIsValidateTriggered(true);
        };
        window.addEventListener("validate-text-field", handleIsValidateTriggered);
        return () => {
            window.removeEventListener("validate-text-field", handleIsValidateTriggered);
        };
    }, []);
    return (_jsxs("div", { children: [_jsxs("div", { children: [titleLabel !== "" && (_jsxs("label", { className: "block text-md font-medium text-gray-700 dark:text-gray-400", children: [titleLabel, isRequired && titleLabel !== "" && (_jsx("span", { className: "text-error-500 ml-1", children: "*" }))] })), subtitleLabel !== "" && (_jsx("p", { className: "text-sm text-gray-400 dark:text-gray-300 mb-2.5", children: subtitleLabel })), _jsx("input", { id: componentID, name: inputName, value: inputText, type: "text", placeholder: placeholder, onChange: (e) => setInputText(e.target.value), onBlur: () => setTouched(true), className: `dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border ${showInvalid ? `border-error-300` : `border-gray-300`} bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden ${showInvalid ? `dark:border-error-700` : `dark:border-gray-700`}  dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30` })] }), showInvalid && (_jsx("p", { className: "text-theme-xs text-error-500 mt-1", children: feedbackMessage }))] }));
});
export default FieldText;
